/**
 * Função para formatar datas em string no formato brasileiro (dd/mm/yyyy)
 *
 * @param data - A data que será formatada. Pode ser uma string no formato compatível com a ISO 8601
 * (ex: "YYYY-MM-DD" ou "YYYY-MM-DDTHH:MM:SSZ") ou `undefined`. No caso de `undefined`, a função retorna uma string vazia.
 *
 * @returns Retorna a data formatada no padrão brasileiro (dd/mm/yyyy) se a entrada for uma string de data válida.
 * Se a entrada for `undefined`, retorna uma string vazia ('').
 *
 * @example
 * formataData("2023-07-31") // retorna "31/07/2023"
 * formataData(undefined) // retorna ""
 */
const formataData = (data: string | undefined): string => {
  if (!data) return ''
  return new Date(data).toLocaleDateString('pt-BR')
}
export default formataData

/**
 * Formata a parte de data de uma string ISO sem conversão de fuso horário.
 * Extrai apenas a parte "YYYY-MM-DD" do string e retorna "dd/MM/yyyy".
 * Evita o problema de datas virando um dia antes em UTC-3.
 */
export const formataDataISO = (data: string | null | undefined): string => {
  if (!data) return ''
  const datePart = data.split('T')[0]
  const parts = datePart.split('-')
  if (parts.length !== 3) return ''
  return `${parts[2]}/${parts[1]}/${parts[0]}`
}

export const formataDataHora = (data: string | Date | undefined): string => {
  if (!data) return '-'
  const datetime = new Date(data)
  const formattedDate = `${datetime.getDate()}/${datetime.getMonth() + 1}/${datetime.getFullYear()}`

  const formattedMinutes = `0${datetime.getMinutes()}`.slice(-2)

  const formattedTime = `${datetime.getHours()}:${formattedMinutes}`
  const formattedDateTime = `${formattedDate} ${formattedTime}`

  return formattedDateTime
}

export function formatDateServer(startDate: Date, endDate: Date | null = null) {
  let formattedStartDate = new Date(startDate)
  formattedStartDate.setHours(0, 0, 0, 0)
  formattedStartDate = new Date(
    formattedStartDate.getTime() - formattedStartDate.getTimezoneOffset() * 60000
  )

  let formattedEndDate: Date

  if (endDate) {
    formattedEndDate = new Date(endDate)
    formattedEndDate.setHours(23, 59, 59, 999)
    formattedEndDate = new Date(
      formattedEndDate.getTime() - formattedEndDate.getTimezoneOffset() * 60000
    )
  } else {
    const lastDay = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0, 23, 59, 59)
    formattedEndDate = new Date(lastDay.getTime() - lastDay.getTimezoneOffset() * 60000)
  }

  return {
    startDate: formattedStartDate,
    endDate: formattedEndDate
  }
}
